import {
  Container,
  Heading,
} from "@chakra-ui/react"

import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

import ToolsSection from "@/components/Tools/ToolsSection"

const reportsSearchSchema = z.object({
  page: z.number().catch(1),
})

export const Route = createFileRoute("/_layout/tools")({
  component: Reports,
  validateSearch: (search) => reportsSearchSchema.parse(search),
})

function Reports() {
  return (
    <Container maxW="full" pt={4} overflowY="auto">
      <Heading size="lg" pt={4}>
        도구 관리
      </Heading>
      <ToolsSection />
    </Container>
  )
}
